import "./AddUser.scss";

import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import ExportFields from "./Config";
import SectionLoader, { LOADER_POSITION, LOADER_TYPE } from "@/src/components/common/Elements/Spinner/SectionLoader/SectionLoader";
import UserType from "./Field//UserType/UserType";
import ExistingUsers from "./Field/ExistingUsers/ExistingUsers";
import Field from "./Field/Field";

const initState = {
    usernameHasError: false,
    emailHasError: false,
    userType: {value: null, label: "Select"},
    existingUserSelected: false,
    isClose: false,
    isTyping: true,
    data: {
        id: null,
        emailAddress: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        username: "",
        position: "",
        userRole: {value: 5, label: "External Manager"},
        supervisors: ""
    }
}

@connect(store => {
    return {}
})

class AddUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...initState, showConfirm: false, isLoading: false };
    }

    // Save handler: show confirmation modal immediately after closing add user modal
    handleSave = () => {
        this.setState({ showConfirm: true }, () => {
            setTimeout(() => {
                $("#addNewMemberModal").modal("hide");
            }, 10);
        });
    }

    // Confirm handler: actually add member and close modals
    handleConfirmAdd = async () => {
        const { project, selectedType, onAddMember } = this.props;
        let payload = { ...this.state.data };
        this.setState({ isLoading: true });
        try {
            if (onAddMember) {
                const result = onAddMember(payload);
                if (result && typeof result.then === 'function') {
                    await result;
                }
            }
            this.setState({ ...initState, showConfirm: false, isClose: true, isLoading: false }, () => {
                $("#addNewMemberModal").modal("hide");
            });
        } catch (e) {
            this.setState({ isLoading: false });
        }
    }

    // Cancel confirmation modal
    handleCancelConfirm = () => {
        this.setState({ showConfirm: false });
    }


    render() {
        const { project } = this.props;
        const isDisabled = (
            (this.props.selectedType === "External" && this.state.userType.value === null) || 
            (this.props.selectedType === "External" && this.state.userType.value === "existing" && !this.state.existingUserSelected) || 
            (this.props.selectedType === "Internal" && !this.state.existingUserSelected)
        );
        
        const Fields = ExportFields({
            state: this.state,
            type: this.props.selectedType,
            project: project,
            onSetState: (u, cb) => this.setState({...this.state, ...u}, cb)
        });

        const fieldsHasChanges = () => {
            let filled = 0;

            const fields = {...Fields.main, ...Field.others};
            const requiredFields = Object.keys(fields).filter(f => fields[f].required && fields[f].type !== "display");

            for(const f of requiredFields) {
                if (f === 'username' || f === 'firstName' || f === 'lastName') {
                    filled = (fields[f].value !== null && typeof fields[f].value === 'string' && fields[f].value.trim().length > 0) ? filled + 1 : filled;
                } else {
                    filled = fields[f].value ? filled + 1 : filled;
                }
            }

            return filled === requiredFields.length;
        }

        const handleClose = () => {
            this.setState({...initState, isClose: true}, () => {
                $("#addNewMemberModal").modal("hide");
            });
        }

        const handleUserType = (selected) => {
            this.setState({ ...initState, userType: selected, existingUserSelected: false, isClose: false });
            if (this.props.onUserTypeChange) {
                this.props.onUserTypeChange(selected.value); // Notify parent about the selected value
            }
        }

        const handleExistingUser = update => {
            this.setState({...this.state, ...update});
        }
        
        return (
            <>
                {this.state.isLoading && (
                    <SectionLoader loaderPosition={LOADER_POSITION.absolute} loaderType={LOADER_TYPE.screen} />
                )}
                <div class="modal fade add-new-member-modal bg-overlay" data-backdrop="static" data-keyboard="false" id="addNewMemberModal" style={{zIndex: 1052}}>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="row">
                                    <div class="col-lg-10 col-md-10 col-sm-10">
                                        <p>Add Member</p>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2">
                                        <a  class="text-right" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                            <i class="material-icons">close</i>
                                        </a>
                                    </div>
                                </div>    
                            </div>
                            <div class="modal-body">
                                <div class="formHeader">
                                    {this.props.selectedType === "External" && (
                                        <div class="formContainer">
                                            <label>Select</label>
                                            <UserType 
                                                onChange={handleUserType} 
                                                selected={this.state.userType} 
                                                isClose={this.state.isClose}
                                            />
                                        </div>
                                    )}
                                    {(this.state.userType.value === "existing" || this.props.selectedType === "Internal") && (
                                        <div class="formContainer existingUsers">
                                            <label>Username</label>
                                            <ExistingUsers 
                                                type={this.props.selectedType} 
                                                existingMembers={this.props.members} 
                                                onSetState={handleExistingUser}
                                                isClose={this.state.isClose}
                                                onClose={u => this.setState({...this.state, isClose: u})}
                                            />
                                        </div>
                                    )}
                                </div>
                                {Object.keys(Fields.main).length > 0 && (
                                    <div class={`formBody ${this.state.userType.value === "existing" || this.props.selectedType === "Internal" ? "existingContainer" : ""}`}>
                                        <label class={`requiredNote ${this.state.userType.value === null ? "disabled" : ""}`}>(<sup>*</sup>) Indicates a required field</label>
                                        <div class="formSection">
                                            {Object.keys(Fields.main).map(k => (
                                                <Field 
                                                    field={Fields.main[k]} 
                                                    isTyping={this.state.isTyping}
                                                    isDisabled={isDisabled}
                                                    isExistingSelected={this.state.existingUserSelected}
                                                    userType={this.props.selectedType === "Internal" ? "existing" : this.state.userType.value} 
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {Object.keys(Fields.others).length > 0 && (
                                    <div class="formFooter">
                                        {Object.keys(Fields.others).map(k => (
                                            <Field 
                                                field={Fields.others[k]} 
                                                isTyping={this.state.isTyping}
                                                isDisabled={isDisabled}
                                                isExistingSelected={this.state.existingUserSelected}
                                                userType={this.props.selectedType === "Internal" ? "existing" : this.state.userType.value} 
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div class="modal-footer">
                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                        <button type="button" class={`btn btn-secondary btn-cancel `} data-dismiss="modal" onClick={handleClose}>Cancel</button>
                                        <button 
                                            type="button" 
                                            class={`btn btn-create ${(!fieldsHasChanges() || isDisabled || this.state.emailHasError || this.state.usernameHasError) ? "disabled" : "active"}`} 
                                            disabled={!fieldsHasChanges() || isDisabled || this.state.emailHasError || this.state.usernameHasError} 
                                            onClick={this.handleSave}
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Confirmation Modal */}
                {this.state.showConfirm && (
                    <div className="confirm-modal bg-overlay" style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 2000}}>
                        <div className="modal-dialog modal-md" role="document" >
                            <div className="modal-content">
                                <div className="modal-header border-none pd20 pdl40 pdr40">
                                    <div className="row">
                                        <div className="col-lg-10 col-md-10 col-sm-10">
                                            <p className="text-size18 text-black text-semi-bold mb0">You are about to add this user</p>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <a className="text-right text-black" aria-label="Close" onClick={this.handleCancelConfirm}>
                                                <i className="material-icons text-black text-size22">close</i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body bt" style={{ marginLeft: '8px'}}>
                                    <p className="m0 text-black">They will appear under the account with no access until invited.<br />Do you wish to proceed?</p>
                                </div>
                                <div className="modal-footer bt">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-sm-4">
                                            <button type="button" className="btn btn-secondary btn-cancel text-black" onClick={this.handleCancelConfirm}>No</button>
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                            <button type="button" className="btn btn-primary btn-save" onClick={this.handleConfirmAdd}>Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default AddUser;
